import {FormControl, FormField, RadioOption} from 'platform/components';
import {Heading, VStack} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {OverviewForm} from '../types/OverviewForm';

interface DefaultSupplierScopeProps extends RequiredTestIdProps {
  control: FormControl<OverviewForm>;
  formApi: UseFormReturn<OverviewForm>;
}

export function DefaultSupplierScope(props: DefaultSupplierScopeProps) {
  return (
    <VStack spacing={4}>
      <Heading size={5}>{i18n.t('entity.warehouse.labels.articlesDefaultSupplier')}</Heading>
      <FormField
        control={props.control}
        type="radio"
        name="articlesScope.articleScopeArticleDefaultSupplier"
        options={options}
        direction="column"
        spacing={4}
        data-testid={suffixTestId('inputs.defaultSupplierScope', props)}
      />
    </VStack>
  );
}

const ANY = 'ANY';
const ONLY = 'ONLY';

const options: RadioOption[] = [
  {
    label: i18n.t('entity.warehouse.labels.anySupplier'),
    value: ANY,
  },
  {
    label: i18n.t('entity.warehouse.labels.onlyMatchingUpdateSupplier'),
    value: ONLY,
  },
];
